import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api";
import { UserContext } from "./userContext";

const StaffContext = createContext();

export function StaffProvider({ children }) {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, role } = useContext(UserContext);

  const fetchStaff = async () => {
    if (!user) return; // Don't fetch if no user
    setLoading(true);
    try {
      // Use restricted admin endpoint only for platformadmin/manager roles
      const endpoint = (role === 'platformadmin' || role === 'manager') 
        ? "/platformadmin/staff" 
        : "/staff/all";
        
      const response = await api.get(endpoint);
      setStaff(response.data); // Set staff from response.data
    } catch (err) {
      console.error("Failed to fetch staff:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchStaff();
    }
  }, [user]);

  return (
    <StaffContext.Provider value={{ staff, loading, fetchStaff }}>
      {children}
    </StaffContext.Provider>
  );
}

export const useStaff = () => useContext(StaffContext);